<template>
    <div class="list row">
      <div class="col-md-12">
        <h4><font-awesome-icon icon="desktop" /> Change Members Passwords</h4>
        <div class=""></div>
        <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
          {{message}}
        </div>
        <div v-else class="alert" style="color:green">
          <span v-show="processingInProgress" class="spinner-border spinner-border-sm"></span>
          <span v-if="passwordsChangeInProgressText"> Passwords Change in progress!</span>
        </div>
      </div>
      <div class="col-md-12 hgap"></div>
          
      <div class="col-md-4">
        <div class="card-container">
          <div class="card-body">
            <h5 class="card-title">Members' Passwords Reset</h5>
            <p class="card-text">Click on 'Change Passwords' button to change some members' password.</p>
            <form v-if="currentUser" name="form" @submit.prevent="resetMembersPasswords">
              <!-- <button class="btn btn-primary" @click="resetMembersPasswords"><font-awesome-icon icon="arrow-circle-right" /> Change Passwords</button> -->
              <input v-model="currentUser.firstName" type="hidden" id="firstName" name="firstName">
              <input v-model="currentUser.lastName" type="hidden" id="lastName" name="lastName">
              <input v-model="currentUser.username" type="hidden" id="username" name="username">
              <input v-model="currentUser.email" type="hidden" id="email" name="email">
              <input v-model="currentUser.password" type="hidden" id="password" name="password">
              <input v-model="currentUser.newPassword" type="hidden" id="newPassword" name="newPassword">
              <button class="btn btn-primary"><font-awesome-icon icon="arrow-circle-right" /> Change Passwords</button>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card-container2">
          
        </div>
      </div>
      <div class="col-md-12 hgap"></div>
      
    </div>
  </template>
  
  <script>
  import UserService from "../services/user.service";
  import ChangeMembersPasswordsService from "../services/change-members-passwords.service";
  
  export default {
    name: "change-members-passwords",
    data() {
      return {
        currentUser: null,
        processingInProgress: false,
        passwordsChangeInProgressText: false,
        message: '',
        successful: false
      };
    },
    computed: {
      superAdminUser() {
        return this.$store.state.auth.user;
      }
    },
    methods: {
      getUser(id) {
        UserService.get(id)
          .then(response => {
            this.currentUser = response.data;
            console.log(response.data.id);
          })
          .catch(e => {
            console.log(e);
          });
      },
      resetMembersPasswords() {
        this.message = '';
        this.successful = false;
        this.processingInProgress = true;
        this.passwordsChangeInProgressText = true;
        //console.log('resetMembersPasswords method clicked');
        this.currentUser.userType = 'super';
        ChangeMembersPasswordsService.changeMembsPasswords(this.currentUser.username, this.currentUser)
          .then(response => {
            console.log('Members passwords changed successfully!');
            console.log(response);
            this.successful = true;
            this.processingInProgress = false;
            this.passwordsChangeInProgressText = false;
            this.message = 'Members passwords changed successfully!';
            //this.message = response;
            //let responseMessage = response.data.message;
          },
          error => {
            console.log('An error occured: '+error.toString());
            this.successful = false;
            this.processingInProgress = false;
            this.passwordsChangeInProgressText = false;
            this.message = (error.response && error.response.data) || error.message || error.toString();
          })
          .catch(e => {
            console.log('The caugth error is '+e);
            this.successful = false;
            this.processingInProgress = false;
            this.passwordsChangeInProgressText = false;
            this.message = 'Error: '+e.message;
          });
          //End of ChangeMembersPasswordsService.resetMembersPasswords()
        
      } 
  
    },
    mounted() {
      this.message = '';
      console.log('User: '+this.superAdminUser.username);
      this.getUser(this.superAdminUser.id);
    }
  };
  </script>
  
  <style>
  .list {
    text-align: left;
    max-width: 100%;
    margin: auto;
    margin-top: 3.2em;
  }
  .paginate{
    margin-top: 1.7em;
  }
  .hgap{
    clear: both;
    margin-top: 0.1em;
  }
  
  .card-container.card {
    max-width: 450px !important;
    padding: 0 0;
  }
  
  .card-container2.card {
    float: right;
    max-width: 450px !important;
    padding: 0 0;
  }
  
  .card {
    background-color: #f7f7f7;
    padding: 20px 25px 30px;
    margin: 0 auto 25px;
    margin-top: 50px;
  }
  </style>